import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import theme from "../../theme";
import { Link, useParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import useButtonStyles from "../../styles/useButtonStyles";
import axios from "axios";
import { APIConstants, APIModuleConstants } from "../../constants/ApiConstants";
import { useAppSelector } from "../../redux/hooks";
import formatDate, { getFormattedDate } from "../../util/dateFormat";
import { formatDateReport, getEncodedValue } from "../forms/utility";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DownloadForOfflineRoundedIcon from "@mui/icons-material/DownloadForOfflineRounded";
import InputProps, {
  DualInputProps,
} from "../../pages/SharedContents/InputProps";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import { constant } from "../../constants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import {
  SearchToolTip,
  hashKey,
  modelName,
  permissionsConstants,
} from "../../constants/AppConstants";
import ExportDialog from "../../Shared/Components/ExportDialog/ExportDialog";
import { exportData } from "../../services/ApiServices/export";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";
import useDateFilter from "../../Hooks/Filters/useDateFilter";
interface TableColumn {
  key: string;
  header: string;
  searchable?: boolean;
  filterable?: boolean;
}

const ViewReportDetails = () => {
  const { getUserPermission: getEvoucherPermission } = usePermissionGetter(
    "finance",
    "reimbursment_evoucher"
  );

  const { getUserPermission: getMerchantEvoucherPermission } =
    usePermissionGetter(
      permissionsConstants.evoucher_reimbursement,
      permissionsConstants.evoucher_reimbursement
    );

  const buttonStyles = useButtonStyles();
  const [loading, setLoading] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [exportEmail, setExportEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [visited, setVisited] = useState(false);
  const [validEmail, setValidEmail] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [source, setSource] = useState([]);
  const [filterActive, setFilterActive] = useState(false);
  const currentDate = formatDateReport(new Date().toISOString());
  const REPORTID = window.location.pathname.split("/").pop();
  const params = useParams();
  const [updatedDateFilter, setupdatedDateFilter] = useState({});
  const [selectedOption, setSelecteOption] = useState("");

  const [isApiCall, setIsApiCall] = useState(true);
  const dropdownOptions = source;
  const amountFromRef = useRef<HTMLInputElement>();
  const amountToRef = useRef<HTMLInputElement>();
  const reImbursementFromRef = useRef<HTMLInputElement>();
  const reImbursementToRef = useRef<HTMLInputElement>();
  const searchInputRef = useRef<HTMLInputElement>();
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();
  const entityConstants = {
    amount: "amount",
    expiryDate: "expiryDate",
    utiliesedDate: "utilizedDate",
    remimbursement: "reimbursementCost",
    status: "purpose",
  };

  const { selectedDates, onUpdateFiltedDate, valueWithOperator, onResetDate } =
    useDateFilter([entityConstants.utiliesedDate, entityConstants.expiryDate]);
  const { voucherId } = params;
  const voucher = useAppSelector(
    (state: any) => state.persistReducers.financeSlice?.eVoucherList
  );

  const filterHeader = voucher.filter(
    (item: any) => item.reportId === voucherId
  );
  const voucherList = filterHeader[0];

  const columns: TableColumn[] = [
    { key: "transaction_id", header: "Transaction Code" },
    { key: "title", header: "E-Voucher Title" },
    { key: "couponCode", header: "E-Voucher Code" },
    { key: "unitNumber", header: "Unit Number" },
    { key: "amount", header: "e-Voucher Amount" },
    { key: "reimbursementCost", header: "Reimbursement Cost" },
    { key: "ExpiryData", header: "Expiry Date" },
    { key: "utilizedDate", header: "Utilized Date" },
    { key: "purpose", header: "Source of Voucher" },
  ];

  const [detailData, setDetailsData] = useState<any>([]);

  useEffect(() => {
    if (isApiCall) bindFilter();
  }, [isApiCall]);

  // export functionality
  const handleExport = () => {
    setOpenExport(true);
  };
  const handleExportClose = () => {
    setOpenExport(false);
  };

  const HandleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setExportEmail(e.target.value);
    isValidEmail(e.target.value);
  };
  const headerMapping: Record<string, string> = {
    transaction_id: "Transaction Code",
    reportId: "Report ID",
    loyaltyNo: "Loyalty Card No.",
    companyName: "Merchant Company Name",
    merchantName: "Merchant Shop Name",
    utilizedDate: "Utilized Date",
    reimbursementDate: "Verified Date",
    seriesId: "E-voucher Serial No.",
    reimbusersementStatus: "Reimbursement Status",
    amount: "E-voucher Amount (S$)",
    reimbursementCost: "Reimbursement Cost",
    ExpiryData: "Expiry Date",
    purpose: "Source of Voucher",
    title: "E-Voucher Title",
    couponCode: "E-Voucher Code",
  };
  const formatCSVData = (data: any[]) => {
    const order = [
      "Transaction Code",
      "E-Voucher Title",
      "E-Voucher Code",
      "E-voucher Amount (S$)",
      "Reimbursement Cost",
      "Expiry Date",
      "Utilized Date",
      "Source of Voucher",
    ];
    function sortByOrder(object: any, order: any) {
      const sortedObject: any = {};
      order?.forEach((key: any) => {
        if (object?.hasOwnProperty(key)) {
          sortedObject[key] = object[key];
        }
      });
      return sortedObject;
    }
    return data?.map((csvRow) => {
      const renamedRow = {
        ...csvRow,
        Type: "Physical Voucher",
      };
      const excludedColumns = [
        "id",
        "scan_transaction_id",
        "scanner_id",
        "reason",
        "report_id",
        "issue_date",
        "merchant_approval",
        "merchant_name",
        "scan_time_stamp",
        "status",
        "createdAt",
        "updatedAt",
        "merchant_id",
        "bi_status",
        "validity",
        "admin_email",
      ];

      for (const key in renamedRow) {
        if (excludedColumns.includes(key)) {
          delete renamedRow[key];
        } else {
          if (headerMapping[key]) {
            renamedRow[headerMapping[key]] = renamedRow[key];
            delete renamedRow[key];
          }
        }
      }

      if (renamedRow.navigateTo) {
        delete renamedRow.navigateTo;
      }

      return sortByOrder(renamedRow, order);
    });
  };

  const handleLocalDownload = () => {
    const exportableData = formatCSVData(detailData);

    if (exportableData.length > 0) {
      const fields = Object.keys(exportableData[0]);
      const csvRows = [fields.join(",")];

      for (const row of exportableData) {
        const values = fields.map((field) => JSON.stringify(row[field]));
        csvRows.push(values.join(","));
      }

      const csvContent = `Report Title: e-Voucher Reimbursement Report\n Report ID : ${REPORTID}\nExport Date: ${currentDate}\n${csvRows.join(
        "\n"
      )}`;
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "e-voucher.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } else {
      console.error("No data to export");
    }
  };

  const handleSendExport = async () => {
    const getFilterURL = getParams();
    setSending(true);
    const handleExportFun = await exportData(
      getFilterURL,
      modelName.utilizedVouchers,
      hashKey.reportId,
      `${REPORTID}`
    );
    handleExportFun.data.status && setEmailSent(true);
    setSending(false);
    setTimeout(() => {
      setEmailSent(false);
    }, 3000);
  };

  const isValidEmail = (email: any) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(email)) {
      setValidEmail(true);
    } else {
      setValidEmail(false);
    }
  };

  const onInputChange = (filedName: string, value: any) => {
    setupdatedDateFilter((prevState) => ({
      ...prevState,
      [filedName]: value,
    }));
  };
  const getDateValue = (fieldItem: any) => {
    const item = updatedDateFilter[fieldItem as keyof typeof updatedDateFilter];
    return item !== undefined ? item : "";
  };
  const getFilterDates = () => {
    const data = Object.keys(updatedDateFilter).map((item: any) => {
      return {
        fieldValue: item,
        value: new Date(
          updatedDateFilter[item as keyof typeof updatedDateFilter]
        )
          .getTime()
          .toString(),
        operator: operatorConstants.equal,
      };
    });
    return data;
  };
  const getFilterAmount = () => {
    const amount_From = amountFromRef.current?.value;
    const amount_to = amountToRef.current?.value;
    const reimbursement_Amount_From = reImbursementFromRef.current?.value;
    const reimbursement_Amount_To = reImbursementToRef.current?.value;
    let amntField = {};
    let reimbursementAmntField = {};

    const amountValue = {
      fieldValue: entityConstants.amount,
      value: [amount_From, amount_to],
      operator: operatorConstants.between,
    };
    const reImbursementamountValue = {
      fieldValue: entityConstants.remimbursement,
      value: [reimbursement_Amount_From, reimbursement_Amount_To],
      operator: operatorConstants.between,
    };
    amntField = amount_From && amount_to ? amountValue : {};
    reimbursementAmntField =
      reimbursement_Amount_From && reimbursement_Amount_To
        ? reImbursementamountValue
        : {};
    const amnt_data = [];
    if (Object.keys(amntField).length !== 0) amnt_data.push(amntField);
    if (Object.keys(reimbursementAmntField).length !== 0)
      amnt_data.push(reimbursementAmntField);
    return amnt_data;
  };
  const getFilterStatus = () => {
    const statusParam = [];
    if (selectedOption !== "")
      statusParam.push({
        fieldValue: entityConstants.status,
        value: selectedOption,
        operator: operatorConstants.equal,
      });
    return statusParam;
  };
  const getFilterValues = () => {
    const idFilter = getNormalFilter();
    // const dates = getFilterDates();
    const dates = valueWithOperator;
    const amount = getFilterAmount();
    const status = getFilterStatus();
    return [...idFilter, ...dates, ...amount, ...status];
  };
  const searchHandler = () => {
    setIsApiCall(true);
    setDetailsData([]);
  };
  const handleApplyFilter = () => {
    setOpenFilter(false);
    searchHandler();
    const filters = getFilterValues().slice(1);
    filters.length && setFilterActive(true);
  };
  const handleResetFilter = () => {
    setupdatedDateFilter({});
    setSelecteOption("");
    onResetDate();
    resetReference(amountFromRef);
    resetReference(amountToRef);
    resetReference(reImbursementFromRef);
    resetReference(reImbursementToRef);
    searchHandler();
    setFilterActive(false);
  };
  const handleCloseFilter = () => {
    setOpenFilter(false);
  };
  const bindFilter = () => {
    getParams();
    fetchData();
    fetchSource();
  };
  const getParams = () => {
    const hashValues = { field: "placeholderId", value: "ALL-RECORDS" };
    const searchValue = searchInputRef.current
      ? getEncodedValue(searchInputRef.current.value)
      : "";
    const searchParam = searchValue !== "" ? [searchValue] : [];
    const filterItems = getFilterValues();
    const params = {
      hashData: hashValues,
      searchData: searchParam,
      filterData: filterItems,
    };
    const url = getHashURL(params);
    return url;
  };
  const resetReference = (refComponent: any) => {
    if (refComponent.current) refComponent.current.value = "";
  };
  const getNormalFilter = () => {
    let filterItems = [
      {
        fieldValue: "reportId",
        operator: operatorConstants.equal,
        value: voucherId,
      },
    ];
    return filterItems;
  };

  const fetchSource = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + APIConstants.offers + "?type=source"
      );

      const ConvertToObject = response?.data?.data?.source.map(
        (source: any) => ({
          id: source,
          label: source,
        })
      );
      setSource(ConvertToObject);
    } catch (error) {
      console.error("Error fetching source:", error);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      let url = `${process.env.REACT_APP_API_URL}${APIConstants.getReportById}`;
      const filterParams = getParams();
      url += `?${filterParams}`;
      if (constant.domain === process.env.REACT_APP_MERCHANT_DOMAIN) {
        url += `&module=evoucher_reimbursement&feature=evoucher_reimbursement`;
      } else {
        url += `&module=finance&feature=reimbursment_evoucher`;
      }
      if (!detailData?.length)
        getTotalRecordsCount(
          APIModuleConstants.voucherTransactions,
          filterParams
        );
      const voucherResponse = await axios.get(url);
      const result = voucherResponse.data.result.data.value;
      const mappedData = result.map((voucher: any) => {
        return {
          ...voucher,
          amount: `S$ ${voucher.amount}`,
          ExpiryData: formatDate(voucher.expiryDate),
          utilizedDate: formatDate(voucher.utilizedDate),
          reimbursementDate: formatDate(voucher.reimbursementDate),
          createdDate: formatDate(voucher.createdAt),
          reimbursementCost: `S$ ${voucher.reimbursementCost}`,
          unitNumber: voucher?.unit_number

        };
      });
      setDetailsData(mappedData);
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
      setIsApiCall(false);
    }
  };

  const isHavingPermission = (key: string) => {
    return getEvoucherPermission(key) || getMerchantEvoucherPermission(key);
  };

  return (
    <Grid
      sx={{ background: theme.color?.background }}
      borderRadius={"16px"}
      overflow={"hidden"}
    >
      <ExportDialog
        closeDialog={setOpenExport}
        emailSent={emailSent}
        exportTitle="e-Voucher Report"
        handleClose={handleExportClose}
        open={openExport}
        sending={sending}
        handleSendExport={handleSendExport}
      />
      <Dialog
        onClose={handleCloseFilter}
        open={openFilter}
        sx={{ ml: "60vw", mb: "12vh" }}
      >
        <Grid sx={{ width: "483px", py: 4, px: 2 }}>
          <DialogTitle
            display={"flex"}
            justifyContent={"space-between"}
            borderBottom={theme.border?.smallGrey}
          >
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                color: theme.color?.primary,
                fontSize: theme.font?.fontSize.large,
                fontWeight: theme.font?.fontWeight.thicker,
                textTransform: "capitalize",
              }}
            >
              Filter
            </Typography>
            <IconButton onClick={handleCloseFilter}>
              <CloseOutlinedIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                fontSize: theme.font?.fontSize.medium,
                fontWeight: theme.font?.fontWeight.thick,
              }}
            >
              Total Amount($)
            </Typography>
            <Grid display={"flex"} gap={2} mt={2} direction={"row"}>
              <TextField
                sx={{
                  display: "flex",
                  width: "50%",
                }}
                type="text"
                placeholder="From"
                inputRef={amountFromRef}
              />
              <TextField
                sx={{
                  display: "flex",
                  width: "50%",
                }}
                type="text"
                placeholder="To"
                inputRef={amountToRef}
              />
            </Grid>
            {/* <InputProps
              label="Expiry Date"
              type="date"
              inputPlaceHolder="select"
              onInputChange={(data) =>
                onInputChange(entityConstants.expiryDate, data.target.value)
              }
              value={getDateValue(entityConstants.expiryDate)}
            /> */}
            <DualInputProps
              label="Expiry Date"
              fromTitle="From"
              toTitle="To"
              fromOnChange={(data) => {
                onUpdateFiltedDate(
                  entityConstants.expiryDate,
                  "fromDate",
                  data.target.value
                );
              }}
              toOnChange={(data) => {
                onUpdateFiltedDate(
                  entityConstants.expiryDate,
                  "toDate",
                  data.target.value
                );
              }}
              fromValue={
                selectedDates[
                  entityConstants.expiryDate
                ]?.fromDate?.toString() || ""
              }
              toValue={
                selectedDates[entityConstants.expiryDate]?.toDate?.toString() ||
                ""
              }
              type="Date"
            />
            {/* <InputProps
              label="Utilized Date"
              type="date"
              inputPlaceHolder="select"
              onInputChange={(data) =>
                onInputChange(entityConstants.utiliesedDate, data.target.value)
              }
              value={getDateValue(entityConstants.utiliesedDate)}
            /> */}
            <DualInputProps
              label="Utilized Date"
              fromTitle="From"
              toTitle="To"
              fromOnChange={(data) => {
                onUpdateFiltedDate(
                  entityConstants.utiliesedDate,
                  "fromDate",
                  data.target.value
                );
              }}
              toOnChange={(data) => {
                onUpdateFiltedDate(
                  entityConstants.utiliesedDate,
                  "toDate",
                  data.target.value
                );
              }}
              fromValue={
                selectedDates[
                  entityConstants.utiliesedDate
                ]?.fromDate?.toString() || ""
              }
              toValue={
                selectedDates[
                  entityConstants.utiliesedDate
                ]?.toDate?.toString() || ""
              }
              type="Date"
            />
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                fontSize: theme.font?.fontSize.medium,
                fontWeight: theme.font?.fontWeight.thick,
                marginTop: 3,
              }}
            >
              Reimbursement cost($)
            </Typography>
            <Grid display={"flex"} gap={2} mt={2} direction={"row"}>
              <TextField
                sx={{
                  display: "flex",
                  width: "50%",
                }}
                type="text"
                placeholder="From"
                inputRef={reImbursementFromRef}
              />
              <TextField
                sx={{
                  display: "flex",
                  width: "50%",
                }}
                type="text"
                placeholder="To"
                inputRef={reImbursementToRef}
              />
            </Grid>
            <InputProps
              label="Source of Voucher"
              type="Select"
              inputPlaceHolder="select"
              onInputChange={(data) => setSelecteOption(data.target.value)}
              value={selectedOption}
              options={dropdownOptions}
            />
          </DialogContent>
          <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
            <Button
              sx={{ ...buttonStyles.outlinedSecondary }}
              onClick={handleResetFilter}
            >
              Reset
            </Button>
            <Button
              sx={{ ...buttonStyles.containedSecondary }}
              onClick={handleApplyFilter}
            >
              Apply
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>
      <Grid
        height={"6rem"}
        p={3}
        px={4}
        alignItems={"center"}
        sx={{ backgroundColor: theme.color?.background }}
        display={"flex"}
        justifyContent={"space-between"}
        borderBottom={theme.border?.newGreyBorder}
      >
        <Grid display={"flex"} gap={1}>
          <Grid
            item
            sx={{ cursor: theme?.cursor?.pointer }}
            display={"flex"}
            alignItems={"center"}
          >
            {constant.domain === process.env.REACT_APP_MERCHANT_DOMAIN && (
              <Link to={"/eVoucher"}>
                <ArrowBackIosIcon
                  sx={{ color: theme.color?.primary, textDecoration: "none" }}
                />
              </Link>
            )}
            {constant.domain === process.env.REACT_APP_ADMIN_DOMAIN && (
              <Link to={"/finance"}>
                <ArrowBackIosIcon
                  sx={{ color: theme.color?.primary, textDecoration: "none" }}
                />
              </Link>
            )}
          </Grid>
          <Typography
            variant="h6"
            sx={{
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 600,
            }}
          >
            Report Details
          </Typography>
        </Grid>
        <Grid display={"flex"} gap={2} alignItems={"center"}>
          {isHavingPermission("export") && (
            <CommonButton
              buttonTitle="Export"
              variant="text"
              color="secondary"
              onClick={handleExport}
              disabled={!detailData.length}
            />
          )}
          {isHavingPermission("download") && (
            <CommonButton
              buttonTitle="Download"
              variant="text"
              color="secondary"
              onClick={handleLocalDownload}
              disabled={!detailData.length}
              endIcon={<DownloadForOfflineRoundedIcon />}
            />
          )}
          <SearchInput
            HelpTip={SearchToolTip.EvoucherDetails}
            onCallBack={searchHandler}
            ref={searchInputRef}
          />
          <Button
            variant="text"
            startIcon={
              filterActive ? (
                <FilterAltIcon sx={{ color: theme.color?.secondary }} />
              ) : (
                <FilterAltOutlinedIcon />
              )
            }
            sx={{
              color: theme.color?.newFilterGrey,
              textTransform: "capitalize",
            }}
            onClick={() => setOpenFilter(true)}
          >
            Filter
          </Button>
        </Grid>
      </Grid>
      <Grid p={2} pl={4} pr={4}>
        <Grid
          sx={{ backgroundColor: theme.color?.background }}
          borderRadius={4}
          p={3}
          pl={4}
          gap={2}
          mt={3}
          border={theme.border?.newGreyBorder}
        >
          <Grid width={"50%"}>
            <Grid display={"flex"} gap={2} pl={3}>
              <Typography
                width={"30%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                }}
              >
                Merchant Name :
              </Typography>
              <Typography
                width={"70%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.dark,
                }}
              >
                {voucherList && voucherList.merchant}
              </Typography>
            </Grid>
            <Grid display={"flex"} gap={2} pl={3}>
              <Typography
                width={"30%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                }}
              >
                Report ID :
              </Typography>
              <Typography
                width={"70%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.dark,
                }}
              >
                {voucherList && voucherList.reportId}
              </Typography>
            </Grid>
            <Grid display={"flex"} gap={2} pl={3}>
              <Typography
                width={"30%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                }}
              >
                Submitted :
              </Typography>
              <Typography
                width={"70%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.dark,
                }}
              >
                {voucherList && voucherList.submittedDate}
              </Typography>
            </Grid>
            <Grid display={"flex"} gap={2} pl={3}>
              <Typography
                width={"30%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                }}
              >
                Report type :
              </Typography>
              <Typography
                width={"70%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.dark,
                }}
              >
                {detailData.length ? detailData[0].purpose : "-"}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container width={"100%"} px={3} mt={3}>
        <InfiniteTable
          header={columns}
          contentItems={detailData}
          hasMoreRecords={false}
          isInitialLoading={detailData.length === 0 && loading}
          totalRecords={totalCount}
        />
      </Grid>
    </Grid>
  );
};

export default ViewReportDetails;
